import sales from './sales'
import purchase from './purchase'
import safes from './safes'
import stores from './stores'
import capitals from './capitals'
import discounts from './discounts'
import cheques from './cheques'
import loyaltyPoints from './loyaltyPoints'
import manufacturing from './manufacturing'
import employees from './employees'
import partners from './partners'
import shippings from './shipping'
import pointOfSales from './pointOfSales'
import plugins from './plugins'
import setting from './setting'
import reports from './reports'
import accounting from './accounting'
import branches from './branches'
import discountCodes from './discountCodes'
import callCenter from './callCenter'
import operatingCycles from './operatingCycles'
// Admin pages - converted to lazy loading
const container = () => import('@/pages/container.vue')
const main = () => import('@/pages/main/main.vue')

// GeneralViews - converted to lazy loading
const NotFound = () => import('@/pages/404.vue')
const login = () => import('@/pages/login.vue')

const routes = [
  {
    path: '/',
    component: container,
    redirect: '/accounting',
    children: [
      { path: '/', name: 'main', component: main },
      ...sales,
      ...purchase,
      ...safes,
      ...stores,
      ...capitals,
      ...discounts,
      ...discountCodes,
      ...cheques,
      ...loyaltyPoints,
      ...manufacturing,
      ...employees,
      ...partners,
      ...shippings,
      ...pointOfSales,
      ...branches,
      ...plugins,
      ...setting,
      ...reports,
      ...accounting,
      ...callCenter,
      ...operatingCycles
    ]
  },
  { path: '/login', component: login },
  { path: '*', component: NotFound }
]

export default routes
